export default __webpack_public_path__ + "static/50-becb822af02396fedda58edb1d4b2c43.png";